module.exports = __webpack_public_path__ + "img/6.be44e0b8.png";